module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/guest_list-e65340de7b5525f1f34aeeef08bfae8a.webp";